import createCache from "@emotion/cache";

export const emotionCacheBenchmarking = createCache({ key: "bm-css" });

export const emotionCacheCm = createCache({ key: "cm-css" });
